import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.profile.topImages;

//VERIFY IF THE JWT IS SET
const getMemberTopImages = createSelector(getData, images => images);
export default getMemberTopImages;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberTopImages.js